module.exports = __webpack_public_path__ + "img/slide-12.867818c4.jpeg";